import { Role } from '../model/enum/role';
import { MenuItem } from '../model/menu-item';

export const SIDE_MENU: MenuItem[] = [
  {
    id: 1,
    name: 'Companies',
    path: '/companies',
    icon: 'company',
    allowedRoles: [Role.SUPER_ADMIN],
    children: [],
  },
  {
    id: 2,
    name: 'Plans',
    path: '/plans',
    icon: 'side-menu-plans',
    allowedRoles: [Role.SUPER_ADMIN],
    children: [],
  },
  {
    id: 3,
    name: 'Subscriptions',
    path: '/subscriptions',
    icon: 'subscriptions',
    allowedRoles: [Role.SUPER_ADMIN],
    children: [],
  },
  {
    id: 4,
    name: 'Dashboard',
    path: '/dashboard',
    icon: 'dashboard',
    children: [],
    allowedRoles: [Role.SUPER_ADMIN, Role.ADMIN, Role.MANAGER],
  },
  {
    id: 5,
    name: 'Transactions',
    path: '/transactions',
    icon: 'transactions',
    allowedRoles: [Role.SUPER_ADMIN, Role.ADMIN, Role.MANAGER, Role.CASHIER],
    children: [],
  },
  {
    id: 19,
    name: 'Expenses',
    path: '/expenses',
    icon: 'expenses',
    allowedRoles: [Role.SUPER_ADMIN, Role.ADMIN, Role.MANAGER],
    children: [],
  },
  {
    id: 6,
    name: 'Kitchen',
    path: '/kitchen',
    icon: 'chef-hat',
    allowedRoles: [
      Role.SUPER_ADMIN,
      Role.ADMIN,
      Role.MANAGER,
      Role.CASHIER,
      Role.KITCHEN,
    ],
    children: [
      {
        id: 1,
        name: 'Live Orders',
        path: '/kitchen/live-orders',
        icon: '',
        allowedRoles: [Role.SUPER_ADMIN, Role.ADMIN, Role.MANAGER, Role.CASHIER, Role.KITCHEN],
        children: [],
      },
      {
        id: 2,
        name: 'Wastage',
        path: '/kitchen/wastage',
        icon: '',
        allowedRoles: [Role.SUPER_ADMIN, Role.ADMIN, Role.MANAGER, Role.CASHIER, Role.KITCHEN],
        children: [],
      },
    ],
    requiresFnbStore: true,
  },
  {
    id: 7,
    name: 'Stores',
    path: '/stores',
    icon: 'stores',
    allowedRoles: [Role.SUPER_ADMIN, Role.ADMIN, Role.MANAGER],
    children: [],
  },
  {
    id: 8,
    name: 'Products',
    path: '/products',
    icon: 'products',
    allowedRoles: [Role.SUPER_ADMIN, Role.ADMIN, Role.MANAGER],
    children: [],
  },
  {
    id: 9,
    name: 'Barcodes',
    path: '/barcodes',
    icon: 'barcode',
    allowedRoles: [Role.SUPER_ADMIN, Role.ADMIN, Role.MANAGER, Role.CASHIER],
    children: [],
    requiresRetailStore: true,
  },
  {
    id: 10,
    name: 'Discounts',
    path: '/discounts',
    icon: 'discounts',
    allowedRoles: [Role.SUPER_ADMIN, Role.ADMIN, Role.MANAGER, Role.CASHIER],
    children: [],
  },
  {
    id: 11,
    name: 'Customers',
    path: '/customers',
    icon: 'customers',
    allowedRoles: [Role.SUPER_ADMIN, Role.ADMIN, Role.MANAGER],
    children: [],
  },
  {
    id: 12,
    name: 'Suppliers',
    path: '/suppliers',
    icon: 'suppliers',
    allowedRoles: [Role.SUPER_ADMIN, Role.ADMIN, Role.MANAGER],
    children: [],
  },
  {
    id: 13,
    name: 'Users',
    path: '/users',
    icon: 'id-card',
    allowedRoles: [Role.SUPER_ADMIN, Role.ADMIN],
    children: [],
  },
  {
    id: 14,
    name: 'Analytics',
    path: '/analytics',
    icon: 'analytics',
    allowedRoles: [Role.SUPER_ADMIN, Role.ADMIN, Role.MANAGER],
    children: [
      {
        id: 1,
        name: 'Accounting',
        path: '/analytics/accounting',
        icon: '',
        allowedRoles: [Role.SUPER_ADMIN, Role.ADMIN, Role.MANAGER],
        children: [],
      },
      {
        id: 2,
        name: 'Sales',
        path: '/analytics/sales',
        icon: '',
        allowedRoles: [Role.SUPER_ADMIN, Role.ADMIN, Role.MANAGER],
        children: [],
      },
      {
        id: 3,
        name: 'Register Sessions',
        path: '/analytics/register-sessions',
        icon: '',
        allowedRoles: [Role.SUPER_ADMIN, Role.ADMIN, Role.MANAGER],
        children: [],
      },
    ],
  },
  {
    id: 15,
    name: 'Registers',
    path: '/registers',
    icon: 'cash-register',
    allowedRoles: [Role.SUPER_ADMIN, Role.ADMIN, Role.MANAGER, Role.CASHIER],
    children: [
      {
        id: 1,
        name: 'Registers',
        path: 'registers/list',
        icon: '',
        allowedRoles: [Role.SUPER_ADMIN, Role.ADMIN, Role.MANAGER],
        children: [],
      },
      {
        id: 2,
        name: 'Open/Close Register',
        path: 'registers/open-close-register',
        icon: '',
        allowedRoles: [
          Role.SUPER_ADMIN,
          Role.ADMIN,
          Role.MANAGER,
          Role.CASHIER,
        ],
        children: [],
        allowedOffline: true,
      },
      {
        id: 3,
        name: 'POS',
        path: 'registers/point-of-sales',
        icon: '',
        allowedRoles: [
          Role.SUPER_ADMIN,
          Role.ADMIN,
          Role.MANAGER,
          Role.CASHIER,
        ],
        children: [],
        allowedOffline: true,
      },
    ],
  },
  {
    id: 16,
    name: 'Inventory',
    path: '/inventory',
    icon: 'inventory',
    allowedRoles: [Role.SUPER_ADMIN, Role.ADMIN, Role.MANAGER, Role.CASHIER],
    children: [
      {
        id: 1,
        name: 'Items',
        path: '/inventory/items',
        icon: '',
        allowedRoles: [
          Role.SUPER_ADMIN,
          Role.ADMIN,
          Role.MANAGER,
          Role.CASHIER,
        ],
        children: [],
      },
      {
        id: 2,
        name: 'Purchases',
        path: '/inventory/purchases',
        icon: '',
        allowedRoles: [
          Role.SUPER_ADMIN,
          Role.ADMIN,
          Role.MANAGER,
          Role.CASHIER,
        ],
        children: [],
      },
    ],
  },
  {
    id: 17,
    name: 'Compliance',
    path: '/compliance',
    icon: 'compliance',
    allowedRoles: [Role.SUPER_ADMIN, Role.ADMIN],
    children: [
      {
        id: 1,
        name: 'Reports',
        path: '/compliance/reports',
        icon: '',
        allowedRoles: [Role.SUPER_ADMIN, Role.ADMIN],
        children: [],
      },
    ],
  },
  {
    id: 18,
    name: 'Feature Request',
    path: '/feature-request',
    icon: 'feature-request',
    allowedRoles: [Role.SUPER_ADMIN, Role.ADMIN, Role.MANAGER, Role.CASHIER],
    children: [],
  },
];
